/* ============================================================================
   TV BOX 4K ULTRA — JS de la landing nativa Shopify
   ============================================================================
   Producto NUEVO e independiente del TV Box clásico (productos/tv-box/) — no
   comparte Variant IDs, IDs de DOM ni estado con esa landing.

   Reutiliza tal cual el patrón EasySell ya validado en producción real (TV
   Box clásico, 2026-09-20/21, documentación oficial de Tyslo):
     (a) un botón propio puede abrir el popup real de EasySell agregándole la
         clase oficial "es-popup-button-overwrite";
     (b) el formulario/botón ESTÁNDAR de "Add to cart" debe existir realmente
         en la página (nunca se envía) porque es de ahí de donde EasySell lee
         la "variante actual" al abrirse.
   Coordinación con el listener de EasySell — patrón "swallow-and-replay": el
   click real se intercepta por completo (preventDefault + stopImmediatePropagation,
   registrado en fase de captura), se hace Replace-Before-Add + sincronización,
   y solo al terminar se dispara un click sintético de replay sobre el mismo
   botón (con una bandera interna para reconocerlo y no volver a interceptarlo).

   VARIANT IDS (2026-09-27): reemplazados por los IDs reales del producto
   "TV Box 4K Ultra" (Product ID 10982295273783, handle tv-box-4k-ultra),
   confirmados por el usuario directamente desde Shopify Admin. El guard
   isRealVariantId() sigue intacto (queda como protección permanente, no solo
   mientras hubiera placeholders) — si algún valor dejara de ser puramente
   numérico, la landing vuelve a bloquear la llamada real a la Cart API en vez
   de romper el carrito del cliente.
   ============================================================================ */
(function () {
  if (window.__itpTvBoxUltraInitialized) return;
  window.__itpTvBoxUltraInitialized = true;

  function init() {
    (function () {
      var packsGrid = document.getElementById('itp-packs');
      var buyZone = document.getElementById('itp-buy-zone');
      if (!packsGrid || !buyZone) return;

      var packButtons = packsGrid.querySelectorAll('.itp-pack-select');
      var packCards = packsGrid.querySelectorAll('.itp-pack');

      // Variant IDs reales (2026-09-27) — Product ID 10982295273783,
      // handle tv-box-4k-ultra. Confirmados por el usuario desde Shopify Admin.
      var PACK_VARIANT_IDS = {
        '1': '53030075892023', // 1 unidad — $42.990
        '2': '53030075924791', // 2 unidades — $79.990
        '3': '53030075957559'  // 3 unidades — $114.990
      };

      var CLEANUP_VARIANT_IDS = [
        PACK_VARIANT_IDS['1'],
        PACK_VARIANT_IDS['2'],
        PACK_VARIANT_IDS['3']
      ];

      function isRealVariantId(id) {
        return typeof id === 'string' && /^\d+$/.test(id);
      }

      // Sincroniza la variante activa con el Product Form NATIVO real de Shopify
      // (".itp-native-product-form" en tv-box-4k-ultra-landing-main.liquid). Nunca
      // se envía — solo se mantiene sincronizado como fuente de "variante actual"
      // que EasySell lee al abrirse.
      function syncNativeProductForm(qty) {
        var variantId = PACK_VARIANT_IDS[qty];
        if (!variantId) return;
        var form = document.querySelector('.itp-native-product-form form');
        if (!form) {
          console.warn('[TV Box 4K Ultra] no se encontró el Product Form nativo (.itp-native-product-form form).');
          return;
        }
        var variantInput = form.querySelector('input[name="id"]');
        var quantityInput = form.querySelector('input[name="quantity"]');
        if (variantInput) {
          variantInput.value = variantId;
          variantInput.dispatchEvent(new Event('input', { bubbles: true }));
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (quantityInput) {
          quantityInput.value = '1';
          quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
          quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (isRealVariantId(variantId)) syncVariantUrlParam(variantId);
      }

      // Mantiene "?variant=" sincronizado en la URL sin recargar (history.replaceState),
      // preservando el resto de parámetros existentes (ej. "view=..." de un preview de theme).
      function syncVariantUrlParam(variantId) {
        if (!window.history || !window.history.replaceState) return;
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variantId);
          window.history.replaceState(window.history.state, '', url);
        } catch (err) {
          console.warn('[TV Box 4K Ultra] no se pudo sincronizar "?variant=" en la URL (no crítico).', err);
        }
      }

      // REPLACE BEFORE ADD (nunca /cart/clear.js): limpia únicamente las 3
      // variantes conocidas de TV Box 4K Ultra antes de continuar — nunca toca
      // otros productos que el cliente pudiera tener ya en el carrito.
      async function clearPackVariantsFromShopifyCart() {
        var realIds = CLEANUP_VARIANT_IDS.filter(isRealVariantId);
        if (!realIds.length) {
          throw new Error('Variant IDs todavía no configurados (placeholders) — ver producto.md §7.');
        }
        var updates = {};
        realIds.forEach(function (id) { updates[id] = 0; });
        var response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
        if (!response.ok) {
          throw new Error('No se pudo limpiar el carrito de Shopify antes de continuar (status ' + response.status + ')');
        }
      }

      function scrollToPurchaseMethod() {
        var target = document.getElementById('itp-buy-zone-title') || buyZone;
        var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var offset = window.innerWidth < 700 ? 160 : 90;
        var rect = target.getBoundingClientRect();
        var alreadyWellPositioned = rect.top >= offset && rect.bottom <= window.innerHeight;
        if (alreadyWellPositioned) return;
        var targetTop = rect.top + window.pageYOffset - offset;
        window.scrollTo({ top: targetTop, behavior: prefersReduced ? 'auto' : 'smooth' });
      }

      function selectPack(qty) {
        packsGrid.setAttribute('data-selected-pack', qty);
        packCards.forEach(function (card) {
          var isSelected = card.getAttribute('data-pack') === qty;
          card.classList.toggle('itp-pack-selected', isSelected);
          var btn = card.querySelector('.itp-pack-select');
          if (btn) {
            btn.setAttribute('data-selected', isSelected ? 'true' : 'false');
            btn.textContent = isSelected ? '✓ SELECCIONADO' : btn.getAttribute('data-default-label');
          }
        });
        buyZone.hidden = false;
        syncNativeProductForm(qty); // se repite en CADA selección, nunca solo la primera vez
        scrollToPurchaseMethod();
      }

      packButtons.forEach(function (btn) {
        btn.addEventListener('click', function () { selectPack(btn.getAttribute('data-itp-buy')); });
      });

      // "Paga al recibir" — lleva la clase oficial "es-popup-button-overwrite".
      // Ver cabecera del archivo para la explicación completa del patrón
      // swallow-and-replay.
      var codButton = buyZone.querySelector('[data-buy-method="cod"]');
      if (codButton) {
        var codButtonLabel = codButton.querySelector('strong');
        var codButtonOriginalLabel = codButtonLabel ? codButtonLabel.textContent : null;
        var isReplayingClick = false;

        function restoreCodButton() {
          codButton.disabled = false;
          if (codButtonLabel && codButtonOriginalLabel !== null) {
            codButtonLabel.textContent = codButtonOriginalLabel;
          }
        }

        codButton.addEventListener('click', function (event) {
          if (isReplayingClick) {
            isReplayingClick = false;
            return; // click sintético propio — se deja pasar sin interceptar
          }

          event.preventDefault();
          event.stopImmediatePropagation();

          if (codButton.disabled) return; // evita doble click
          var qty = packsGrid.getAttribute('data-selected-pack');
          var variantId = PACK_VARIANT_IDS[qty];
          if (!variantId) return; // defensivo: la zona de compra solo se revela tras elegir un pack válido

          if (!isRealVariantId(variantId)) {
            console.warn('[TV Box 4K Ultra] Variant ID todavía no configurado para el pack ' + qty + ' — no se abre EasySell. Ver producto.md §7.');
            return;
          }

          codButton.disabled = true;
          if (codButtonLabel) codButtonLabel.textContent = 'Preparando pedido...';
          syncNativeProductForm(qty);

          clearPackVariantsFromShopifyCart()
            .then(function () {
              syncNativeProductForm(qty);
              codButton.disabled = false; // un <button disabled> no dispara click, ni programático
              isReplayingClick = true;
              codButton.click();
            })
            .catch(function (err) {
              console.error('[TV Box 4K Ultra] no se pudo limpiar el carrito antes de abrir EasySell — no se abre el popup.', err);
            })
            .finally(restoreCodButton);
        }, true); // fase de captura
      }

      // "Pago online" — Replace-Before-Add + Ajax Cart (/cart/add.js) + redirección a /checkout.
      var onlineButton = buyZone.querySelector('[data-buy-method="online"]');
      if (onlineButton) {
        var onlineButtonLabel = onlineButton.querySelector('strong');
        var onlineButtonOriginalLabel = onlineButtonLabel ? onlineButtonLabel.textContent : null;

        function restoreOnlineButton() {
          onlineButton.disabled = false;
          if (onlineButtonLabel && onlineButtonOriginalLabel !== null) {
            onlineButtonLabel.textContent = onlineButtonOriginalLabel;
          }
        }

        onlineButton.addEventListener('click', function () {
          if (onlineButton.disabled) return;
          var qty = packsGrid.getAttribute('data-selected-pack');
          var variantId = PACK_VARIANT_IDS[qty];
          if (!variantId) return;

          if (!isRealVariantId(variantId)) {
            console.warn('[TV Box 4K Ultra] Variant ID todavía no configurado para el pack ' + qty + ' — no se agrega al carrito. Ver producto.md §7.');
            return;
          }

          onlineButton.disabled = true;
          if (onlineButtonLabel) onlineButtonLabel.textContent = 'Preparando pedido...';

          clearPackVariantsFromShopifyCart()
            .then(function () {
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
              });
            })
            .then(function (response) {
              if (!response.ok) {
                throw new Error('No se pudo agregar la variante al carrito antes del checkout (status ' + response.status + ')');
              }
              window.location.href = '/checkout';
            })
            .catch(function (err) {
              console.error('[TV Box 4K Ultra] no se pudo preparar el carrito — no se redirige al checkout.', err);
              restoreOnlineButton();
            });
        });
      }
    })();

    // Scroll suave para los CTA que regresan al módulo de compra (#itp-oferta).
    (function () {
      var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      document.querySelectorAll('a[href="#itp-oferta"]').forEach(function (link) {
        link.addEventListener('click', function (e) {
          var target = document.getElementById('itp-oferta');
          if (!target) return;
          e.preventDefault();
          target.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' });
        });
      });
    })();

    // Estado visual del método de pago ("itp-buy-method-selected") — SOLO
    // cosmético: marca qué botón tocó el usuario para que quede destacado
    // (degradado) y el otro vuelva a blanco. Deliberadamente independiente y
    // aditivo: no reemplaza ni reordena los listeners de "Paga al recibir"
    // (swallow-and-replay + EasySell) ni de "Pago online" definidos arriba —
    // solo agrega un listener más sobre los mismos botones. Para "Paga al
    // recibir" corre en el click de replay (el real se intercepta antes),
    // igual de correcto: el estado visual se aplica en el mismo momento en
    // que EasySell recibe el click ya sincronizado. Ningún botón sale
    // marcado al cargar la página.
    (function () {
      var buyMethodButtons = document.querySelectorAll('.itp-buy-method');
      buyMethodButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          buyMethodButtons.forEach(function (other) {
            other.classList.toggle('itp-buy-method-selected', other === button);
          });
        });
      });
    })();

    // Microcopy de ayuda en "Despacho y formas de pago" ("¿itp-envio-help")
    // — SOLO cosmético/UX: visible mientras no haya pack seleccionado,
    // desaparece apenas se elige uno. Deliberadamente independiente y
    // aditivo: lee el mismo "data-selected-pack" que ya mantiene
    // selectPack() (sección de packs, arriba) pero no lo modifica, no abre
    // "Elige cómo pagar", no preselecciona nada y no toca EasySell/variantes.
    // Al hacer click, solo hace scroll suave hasta los packs.
    (function () {
      var helpNote = document.getElementById('itp-envio-help');
      var packsGridEl = document.getElementById('itp-packs');
      if (!helpNote || !packsGridEl) return;

      function syncHelpVisibility() {
        var hasSelection = !!packsGridEl.getAttribute('data-selected-pack');
        helpNote.hidden = hasSelection;
      }

      document.querySelectorAll('.itp-pack-select').forEach(function (btn) {
        btn.addEventListener('click', syncHelpVisibility);
      });

      helpNote.addEventListener('click', function () {
        var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        packsGridEl.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'center' });
      });

      syncHelpVisibility(); // estado inicial correcto también si el script corre después de alguna interacción previa
    })();

    // Acordeón FAQ — sincroniza data-open (visual) con aria-expanded (a11y) en cada botón.
    var faqItems = document.querySelectorAll('.itp-faq-item');
    faqItems.forEach(function (item) {
      var btn = item.querySelector('.itp-faq-q');
      var answer = item.querySelector('.itp-faq-a');
      btn.addEventListener('click', function () {
        var isOpen = item.getAttribute('data-open') === 'true';
        faqItems.forEach(function (other) {
          other.setAttribute('data-open', 'false');
          other.querySelector('.itp-faq-q').setAttribute('aria-expanded', 'false');
          other.querySelector('.itp-faq-a').style.maxHeight = null;
        });
        if (!isOpen) {
          item.setAttribute('data-open', 'true');
          btn.setAttribute('aria-expanded', 'true');
          answer.style.maxHeight = answer.scrollHeight + 'px';
        }
      });
    });

    // Sticky CTA móvil — aria-hidden y tabindex del link deben reflejar SIEMPRE
    // la visibilidad real (nunca aria-hidden="true" con el componente visible/interactivo).
    var sticky = document.getElementById('itp-sticky');
    var stickyLink = document.getElementById('itp-sticky-link');
    var hero = document.querySelector('.itp-hero');
    var offerSection = document.getElementById('itp-oferta');
    if (!sticky || !hero || !offerSection) return;

    function toggleSticky() {
      var shouldShow;
      if (window.innerWidth >= 700) {
        shouldShow = false;
      } else {
        var heroBottom = hero.getBoundingClientRect().bottom;
        var offerRect = offerSection.getBoundingClientRect();
        var offerVisible = offerRect.bottom > 0 && offerRect.top < window.innerHeight;
        shouldShow = heroBottom < 0 && !offerVisible;
      }
      sticky.classList.toggle('itp-sticky-visible', shouldShow);
      sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      if (stickyLink) {
        if (shouldShow) stickyLink.removeAttribute('tabindex');
        else stickyLink.setAttribute('tabindex', '-1');
      }
    }

    window.addEventListener('scroll', toggleSticky, { passive: true });
    window.addEventListener('resize', toggleSticky);
    toggleSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();